var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},_vm._l((_vm.data),function(item,index){return _c('Accordion',{key:item.title,attrs:{"itemKey":index,"title":item.title,"content":item.content,"image":item.image,"order":item.order || 0}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }